var map = {
	"./Frame 12.svg": 73104,
	"./catering-05.jpg": 96219,
	"./catering-06.jpg": 35596,
	"./catering-07.jpg": 90857,
	"./catering-08.jpg": 20050,
	"./catering-09.jpg": 80079,
	"./catering-10.jpg": 23761,
	"./catering-11.jpg": 9428,
	"./catering-12.jpg": 55491,
	"./catering-13.jpg": 96006,
	"./catering-banner.jpg": 69012,
	"./catering-service-01.png": 83901,
	"./catering-service-02.png": 42662,
	"./catering-service-03.png": 81679,
	"./catering-service-04.png": 38832,
	"./catering-service-05.png": 35737,
	"./catering-service-06.png": 87554,
	"./catering-service-07.png": 8683,
	"./catering-service-08.png": 5084,
	"./catering-service-09.png": 34501,
	"./catering-service-10.png": 61439,
	"./catring-01.jpg": 15654,
	"./catring-02.jpg": 43409,
	"./catring-03.jpg": 29076,
	"./catring-04.jpg": 80511,
	"./logo-01.svg": 11259,
	"./logo-02.svg": 95720,
	"./logo-03.svg": 8089,
	"./logo-04.svg": 51254,
	"./logo-05.svg": 98119,
	"./logo-06.svg": 49908
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16770;